import api from "APP_ROOT/api";
import { createChannel } from "APP_ROOT/cable";
import * as dashboardActions from "MODULES/Notifications/actions";
import * as actionTypes from "./actionTypes";

const notificationExists = (id, notifications) =>
  notifications.map(n => n.id).find(i => i === id);

export function setAll(results, totalCount, unreadCount) {
  return {
    type: actionTypes.SET_ALL,
    notifications: results,
    totalCount,
    unreadCount
  };
}

export function fetch(params) {
  return dispatch =>
    api.notifications.search(params).then(({ data }) => {
      dispatch(setAll(data.results, data.total_count, data.data.unread_count));
    });
}

export function remove(noteId) {
  return { type: actionTypes.REMOVE, id: noteId };
}

export function markRead(noteId) {
  return dispatch =>
    api.notifications.update(noteId, { read: true }).then(() => {
      dispatch(dashboardActions.expireNotifications());
      dispatch(dashboardActions.expireSearchNotifications());
      dispatch(
        fetch({
          page: 1,
          limit: 20,
          sort: "id",
          reverse: true,
          filter: true
        })
      );
    });
}

export function onDelete(noteId) {
  return dispatch => {
    dispatch(remove(noteId));

    return api.notifications
      .update(noteId, { deleted_at: new Date() })
      .then(() => {
        dispatch(dashboardActions.expireNotifications());
        dispatch(dashboardActions.expireSearchNotifications());
      });
  };
}

export function expire() {
  return { type: actionTypes.EXPIRE };
}

export function subscribe() {
  return (dispatch, getState) =>
    createChannel().listen("NotificationChannel", {
      onReceive: data => {
        const notifications = getState()
          .notifications.get("notifications")
          .toJS();

        if (data.action === "ADD") {
          if (!notificationExists(data.notification.id, notifications)) {
            dispatch({
              type: actionTypes.ADD,
              notification: data.notification
            });

            const results = getState()
              .searchNotifications.get("results")
              .toJS();

            if (results && results.length === 20) {
              results.pop();
            }

            dispatch({
              type: "@@paginate-this/RESET_RESULTS_searchNotifications",
              results: [data.notification].concat(results)
            });
          }
        } else if (data.action === "REMOVE") {
          if (notificationExists(data.notification.id, notifications)) {
            dispatch(remove(data.notification.id));
            dispatch(dashboardActions.expireNotifications());
            dispatch(dashboardActions.expireSearchNotifications());
          }
        } else if (data.action === "REMOVE_ALL") {
          dispatch(dashboardActions.expireNotifications());
          dispatch(dashboardActions.expireSearchNotifications());
        }
      }
    });
}



// WEBPACK FOOTER //
// ./app/Nav/Notifications/actions.js